import React, { useContext, useEffect, useState } from 'react';
import './homepageStyle.css';
import Navbar from './../../components/navbar/navbar'
import Footer from './../../components/footer/footer'
import AboutUs from './subComponents/aboutUs/aboutUs';
import Equipaments from './subComponents/equipaments/equipaments';
import Applications from './subComponents/applications/applications';
import Contact from './subComponents/contact/contact';
import useSetSiteLanguage from '../../hooks/useSetSiteLanguage';
import HeroSection from './subComponents/heroSection/heroSection';
import NossosParceiros from './../../components/section/pageSections/nossosParceiros/nossosParceiros'
import Section from '../../components/section/section';


export default function Homepage() {

    const siteContent = useSetSiteLanguage();

    const [renderSections, setRenderSections] = useState({
        hero: false,
        equipaments: false,
        applications: false,
        aboutUS: false,
        contact: false,
        nossosParceiros: false,
        footer: false,
    })

    useEffect( () => {
        const timeout = [
            setTimeout( () => setRenderSections( prev => ({...prev,hero: true})), 0),
            setTimeout( () => setRenderSections( prev => ({...prev, equipaments: true})), 100),
            setTimeout( () => setRenderSections( prev => ({...prev, applications: true})), 200),
            setTimeout( () => setRenderSections( prev => ({...prev, aboutUS: true})), 300),
            setTimeout( () => setRenderSections( prev => ({...prev, contact: true})), 400),
            setTimeout( () => setRenderSections( prev => ({...prev, nossosParceiros: true})), 500),
            setTimeout( () => setRenderSections( prev => ({...prev, footer: true})), 600),
        ];

        return () => timeout.forEach(clearTimeout);
    }, [])
    
    return (
        <>
            <Navbar data={siteContent?.navbar}/>
            <div className='homepage__container'>

                <HeroSection />
            

                <Equipaments 
                    text={siteContent?.equipamentsPage?.summary?.text}
                    title={siteContent?.equipamentsPage?.summary?.title} 
                    imgSrc={siteContent?.equipamentsPage?.summary?.photo}/>
                <Applications 
                    title={siteContent?.applicationsPage?.summary?.title}
                    applications={siteContent?.applicationsPage?.applications}
                />
                <AboutUs 
                    text={siteContent?.aboutUsPage?.summary?.text}
                    title={siteContent?.aboutUsPage?.summary?.title} 
                    imgSrc={siteContent?.aboutUsPage?.summary?.photo}/>
                <Section childComponent={
                    <NossosParceiros
                        title={siteContent?.businessPartners?.title} 
                        companies={siteContent?.businessPartners?.companies}/>
                    }
                    sectionId={"parceiros"}/>
                <Contact
                    title={siteContent?.contactSection?.title}
                    text={siteContent?.contactSection?.text}
                    email={siteContent?.contactSection?.email}
                    linkedin={siteContent?.contactSection?.linkedin}
                    whatsapp={siteContent?.contactSection?.whatsapp}/>
               
                
                
            </div>
            <Footer 
                email={siteContent?.contactSection?.email}
                linkedin={siteContent?.contactSection?.linkedin}
                whatsapp={siteContent?.contactSection?.whatsapp}/>
        </>
    );
}
